import { render } from "./ModalNuovaNotaSpesa.vue?vue&type=template&id=e4b19940&scoped=true"
import script from "./ModalNuovaNotaSpesa.vue?vue&type=script&lang=js"
export * from "./ModalNuovaNotaSpesa.vue?vue&type=script&lang=js"

import "./ModalNuovaNotaSpesa.vue?vue&type=style&index=0&id=e4b19940&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_plan_1778832654194047890/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b19940"]])

export default __exports__